import { useState } from 'react';
import { PageLayout } from '@/shared/layout/PageLayout';
import { PackageMinus, Filter } from 'lucide-react';
import { Input } from '@/components/ui';

export function IssuesPage() {
  return (
    <PageLayout title="Danh sách phiếu xuất kho" description="Quản lý lịch sử và các phiếu xuất kho vật tư">
      <div className="flex flex-col h-full gap-4">
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-slate-800">Lịch sử xuất kho</h3>
            <button
              type="button"
              className="inline-flex h-9 items-center justify-center gap-2 rounded-md bg-rose-600 px-4 sm:text-sm text-xs text-white hover:bg-rose-700 transition-colors"
            >
              <PackageMinus className="w-4 h-4" />
              Tạo phiếu xuất
            </button>
          </div>

          <div className="flex items-center gap-3 bg-white p-3 border border-slate-200 rounded-md">
            <div className="relative flex-1 max-w-sm">
              <Filter className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                placeholder="Tìm theo mã phiếu, dự án, người nhận..."
                className="pl-9 h-9 sm:text-sm text-xs"
              />
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto bg-white border border-slate-200 rounded-md p-12 text-center text-slate-500">
          <p>Tính năng danh sách phiếu xuất đang được hoàn thiện.</p>
        </div>
      </div>
    </PageLayout>
  );
}

export default IssuesPage;
